<template>
    <div>
        <!-- Begin Page Content -->
        <div class="medical-records recommended-questionnaire">
            <div class="row">
                <div class="col-12 mb-4">
                    <div class="card border-0">
                        <div class="card-body p-0">
                            <div class="bg-white border-radius-5 p-4 h-100">
                                <div class="row no-gutters">
                                    <div class="col-md-12 Experience">
                                        <h2>Adverse Childhood Experience (ACE)</h2>
                                        <table class="table table-responsive mt-4" border="0" cellspacing="0" cellpadding="">
                                            <thead>
                                                <tr>
                                                    <th>Questions</th>
                                                    <th>Answer</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Name</td>
                                                    <td>psharma@stackflow.org</td>
                                                </tr>
                                                <tr>
                                                    <td>Email</td>
                                                    <td>Punit Sharma</td>
                                                </tr>
                                                <tr>
                                                    <td>Age</td>
                                                    <td>30</td>
                                                </tr>
                                                <tr>
                                                    <td>Country Of Residence</td>
                                                    <td>India</td>
                                                </tr>
                                                <tr>
                                                    <td>Ethnicity</td>
                                                    <td>-</td>
                                                </tr>
                                                <tr>
                                                    <td>Do you drink more than 1 drink a day?</td>
                                                    <td>yes</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Binge Drinking (NIAAA defines binge drinking as a pattern of drinking that brings blood alcohol concentration (BAC) to .08 g/dL. This typically occurs after 4 drinks for women
                                                        and 5 drinks for men—in about 2 hours.)
                                                    </td>
                                                    <td>-</td>
                                                </tr>
                                                <tr>
                                                    <td>I sleep for less than 6.5-8 hours every night</td>
                                                    <td>-</td>
                                                </tr>
                                                <tr>
                                                    <td>I currently smoke/ am exposed to second-hand cigarette smoke</td>
                                                    <td>no</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "intake-questionaries-preview",
        data() {
            return {};
        },
        created(){
           this.pageName('Intake Questionnaire')
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/website/questionaries/intake-questionaries-preview.vue